module.exports = __webpack_public_path__ + "static/pinkfloral3-467b6fe472314b22b6d7b79c8dcc0e66.png";